export const validatePartnerPageName = (pageName) => {
  const re = /^[0-9a-z-]+$/;
  return re.test(pageName);
};
